import InfiniteScroll from 'infinite-scroll'

export default (initialPath = '') => ({
    path: initialPath,
    infiniteScroll: null,

    init() {
        if (!this.path) {
            throw new Error('Path is required for the collection component')
        }

        this.path = `${this.path}?page={{#}}`

        const container = document.querySelector('[data-infinite-scroll-container]')

        if (!container) {
            throw new Error('The collection component requires an element with the following data attribute: data-inifinite-scroll-container')
        }

        this.infiniteScroll = new InfiniteScroll(container, {
            path: this.path,
            append: '[data-product-card]',
            status: '[data-infinite-scroll-spinner]',
            history: false
        })
    }

})
